var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const Svg403 = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 827,
    height: 301,
    viewBox: "0 0 827 301",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_414",
    "data-name": "Group 414",
    transform: "translate(-254 -98)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_1",
    "data-name": "Subtraction 1",
    d: "M234.139,196h-45.3V178.838H95.268L93.23,150.312,188.371,0h45.768V142.319H260v36.519H234.139V196Zm-45.3-134.245-2.978,5.172-47.491,75.391h50.469Z",
    transform: "translate(297.77 169)",
    fill: "#e9f2f6",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_404",
    "data-name": "Group 404",
    transform: "translate(219 -271)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_864",
    "data-name": "Path 864",
    d: "M0,0H168.5V168.5H0Z",
    transform: "translate(385 469)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_401",
    "data-name": "Group 401",
    transform: "translate(398.964 507.084)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_402",
    "data-name": "Group 402",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M126.01,32.927l-10.8,18.9-10.948-18.9H45.443l52.73,91.566,17.478-29.8,17.331,29.8L185.86,32.927ZM96.585,83.889l-17.741-30.9H90.3l12.462,20.8Zm31.16-9.753,12.176-21.144h11.456l-17.741,30.9Z",
    transform: "translate(-45.407 -20.927)",
    fill: "#006ab3"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_3",
    "data-name": "Subtraction 3",
    d: "M671.784,199H528.156a57.364,57.364,0,0,1-5.367-14.141A69.767,69.767,0,0,1,521,168.807h45.3a27.794,27.794,0,0,0,2.41,11.678,26.956,26.956,0,0,0,7.23,9.326,33.385,33.385,0,0,0,10.756,6.113,39.964,39.964,0,0,0,12.99,2.038,45.146,45.146,0,0,0,14.4-2.136A29.86,29.86,0,0,0,625,189.419a27.729,27.729,0,0,0,6.877-9.934,33.775,33.775,0,0,0,2.292-12.716,43.528,43.528,0,0,0-2.351-14.949,26.59,26.59,0,0,0-7.053-10.678,30.339,30.339,0,0,0-11.755-6.407,57.249,57.249,0,0,0-16.458-2.136H572.567V97.178H596.7a47.243,47.243,0,0,0,15.008-2.155,25.911,25.911,0,0,0,10.541-6.465,28.233,28.233,0,0,0,6.23-10.031,37.649,37.649,0,0,0,2.077-12.853A34.262,34.262,0,0,0,628.5,53.408a24.43,24.43,0,0,0-6.172-9.208,26.8,26.8,0,0,0-9.776-5.76,40.174,40.174,0,0,0-12.872-1.92A38.414,38.414,0,0,0,587.731,38.3a30.641,30.641,0,0,0-9.835,5.349,23.59,23.59,0,0,0-6.583,8.209,24.066,24.066,0,0,0-2.194,10.364h-45.3a58.816,58.816,0,0,1,2.41-16.947,55.109,55.109,0,0,1,7.229-15.105A60.156,60.156,0,0,1,545.02,17.535a71.1,71.1,0,0,1,15.4-9.541,85.129,85.129,0,0,1,18.2-6,97.625,97.625,0,0,1,19.965-2,129.533,129.533,0,0,1,17.124,1.083A95.721,95.721,0,0,1,630.874,4.33a74.661,74.661,0,0,1,13.205,5.412,64.108,64.108,0,0,1,11.246,7.577,57.511,57.511,0,0,1,8.983,9.478,54.608,54.608,0,0,1,6.416,11.114,61,61,0,0,1,3.85,12.75,77.694,77.694,0,0,1,1.283,14.386,47.72,47.72,0,0,1-2.39,15.047A50.659,50.659,0,0,1,666.3,93.886a60.939,60.939,0,0,1-11.05,11.638,65.544,65.544,0,0,1-14.028,8.582,67.99,67.99,0,0,1,16.83,8.62,49.339,49.339,0,0,1,11.932,12.069,52.269,52.269,0,0,1,7.112,15.047,62.9,62.9,0,0,1,2.371,17.555,71.514,71.514,0,0,1-1.919,16.846A58.408,58.408,0,0,1,671.785,199h0Z",
    transform: "translate(294.77 166)",
    fill: "#e9f2f6",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_412",
    "data-name": "Group 412"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_411",
    "data-name": "Group 411"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14",
    "data-name": "Rectangle 14",
    width: 57,
    height: 15,
    transform: "translate(1024 257)",
    fill: "#e9f2f6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15",
    "data-name": "Rectangle 15",
    width: 29,
    height: 15,
    transform: "translate(1024 279)",
    fill: "#e9f2f6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_410",
    "data-name": "Group 410"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7",
    "data-name": "Rectangle 7",
    width: 57,
    height: 15,
    transform: "translate(254 234)",
    fill: "#e9f2f6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10",
    "data-name": "Rectangle 10",
    width: 57,
    height: 15,
    transform: "translate(529 139)",
    fill: "#e9f2f6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8",
    "data-name": "Rectangle 8",
    width: 29,
    height: 15,
    transform: "translate(254 256)",
    fill: "#e9f2f6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9",
    "data-name": "Rectangle 9",
    width: 39,
    height: 15,
    transform: "translate(282 211)",
    fill: "#e9f2f6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11",
    "data-name": "Rectangle 11",
    width: 57,
    height: 15,
    transform: "translate(784 121)",
    fill: "#e9f2f6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12",
    "data-name": "Rectangle 12",
    width: 29,
    height: 15,
    transform: "translate(784 143)",
    fill: "#e9f2f6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13",
    "data-name": "Rectangle 13",
    width: 39,
    height: 15,
    transform: "translate(812 98)",
    fill: "#e9f2f6"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_413",
    "data-name": "Group 413"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_875",
    "data-name": "Path 875",
    d: "M110.5,0A110.5,110.5,0,1,1,0,110.5,110.5,110.5,0,0,1,110.5,0Z",
    transform: "translate(577.5 172)",
    fill: "none",
    stroke: "#e9f2f6",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16",
    "data-name": "Rectangle 16",
    width: 200,
    height: 34,
    transform: "translate(588 365)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_406",
    "data-name": "Group 406",
    transform: "translate(30.15 -1189.221)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_405",
    "data-name": "Group 405",
    transform: "translate(552.983 1443.03)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_868",
    "data-name": "Path 868",
    d: "M563,1253.281s89.451,25.408,186.649,0",
    transform: "translate(-556.247 -1233.174)",
    fill: "none",
    stroke: "#ed6467",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_508",
    "data-name": "Ellipse 508",
    cx: 6.5,
    cy: 7.5,
    rx: 6.5,
    ry: 7.5,
    transform: "translate(-0.134 0.191)",
    fill: "#febf2e"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_509",
    "data-name": "Ellipse 509",
    cx: 7,
    cy: 7.5,
    rx: 7,
    ry: 7.5,
    transform: "translate(185.866 0.191)",
    fill: "#febf2e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5",
    "data-name": "Rectangle 5",
    width: 13,
    height: 98,
    transform: "translate(-0.134 15.191)",
    fill: "#6eaad4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6",
    "data-name": "Rectangle 6",
    width: 14,
    height: 98,
    transform: "translate(185.866 15.191)",
    fill: "#6eaad4"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(Svg403, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/403.696d95a1.svg";
export { ForwardRef as ReactComponent };